/* eslint-disable no-console */
/* eslint-disable prefer-promise-reject-errors */

import axios from 'axios';
import store from '../store';
import env from '../.env';
import Vue from 'vue';
import moment from 'moment';

Vue.mixin({
  beforeCreate() {
    const options = this.$options;
    if (options.api) {
      this.$api = options.api;
    } else if (options.parent && options.parent.$api) {
      this.$api = options.parent.$api;
    }
  },
});

const API = {};
const headers = {};
const baseURL = env.API_URL;

API.checkTokenValidity = () => {
  store.dispatch('setLoading', true);
  return new Promise(async (resolve, reject) => {
    try {
      const expiry = store.getters.token_expires;
      const cutoff = moment().add(2, 'm');

      if (expiry.isBefore(cutoff)) {
        // token has expired, or will expire in next 2 mins, so lets refresh it
        await store.dispatch('refreshToken');
      }

      headers.authorizationToken = store.getters.id_token;
      resolve();
    } catch (err) {
      store.dispatch('setLoading', false);
      reject(err);
    }
  });
};

API.getOrgs = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-organizations/organizations?limit=10000`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createOrg = async data => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-organizations/organizations-categories`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.updateOrg = async data => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-organizations/organizations-categories`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.deleteOrg = async data => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-organizations/organizations-categories/delete`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getOrgUsers = async org_id => {
  if (!org_id) {
    throw new Error('missing org_id');
  }

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-users/organization/${org_id}/users?limit=500`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProfile = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-main/my-profile`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getUser = async id => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-users/user/${id}/details`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.updateProfile = async data => {
  const id = data.id;
  delete data.id;

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-users/user/${id}/details`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createUser = async user => {
  let endpoint = 'users/create-user';
  delete user.inviteUser;

  if (user.email) {
    // add them as a Cognito user
    endpoint = 'main/sign-up';
  }

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-${endpoint}`,
        headers,
        data: user,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.deleteUser = async user => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'delete',
        url: `${baseURL}-users/user/${user.id}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProjects = async params => {
  const paramString = getParamString(params);

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-projects/projects?${paramString}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getSelfServiceProjects = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-selfservice/projects`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};


API.createSelfServiceProject = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-selfservice/projects`,
        headers,
        data
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createSelfServiceSession = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-selfservice/vetting/session`,
        headers,
        data
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProjectDetail = async id => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-projects/project/${id}/details`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.saveProject = async (project, type) => {
  let method = 'post';
  let endpoint = 'create-project';

  if (type === 'update') {
    method = 'put';
    endpoint = `project/${project.id}/details`;
  }

  // remove any extraneous data from the project
  const schema_keys = Object.keys(store.getters.project_schema);
  const data = JSON.parse(JSON.stringify(project));
  Object.keys(data).forEach(key => {
    if (!schema_keys.includes(key)) {
      delete data[key];
    }
  });

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method,
        url: `${baseURL}-projects/${endpoint}`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.deleteProject = async id => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'delete',
        url: `${baseURL}-projects/project/${id}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getSuppliers = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-suppliers/suppliers?limit=2000`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createSupplier = async data => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-suppliers/create-supplier`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.saveNewDocuments = async documents => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-main/create-documents`,
        headers,
        data: { documents },
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.updateDocument = async (data, id) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-main/document/${id}/details`,
        headers,
        data,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.deleteDocument = async id => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'delete',
        url: `${baseURL}-main/document/${id}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProjectActions = async id => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-actions/project/${id}/actions?limit=1000`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getActions = async params => {
  const paramString = getParamString(params);

  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-actions/actions?${paramString}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createActionGroups = async actionGroups => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-actions/create-action-groups`,
        headers,
        data: { actionGroups },
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.updateActionGroup = async (actionGroup, id) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-actions/action-group/${id}/details`,
        headers,
        data: actionGroup,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.deleteActionGroups = async actionGroups => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-actions/action-groups/delete`,
        headers,
        data: { actionGroups },
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createActions = async (action_group_id, actions) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-actions/action-group/${action_group_id}/actions`,
        headers,
        data: { actions },
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.updateAction = async (action, id) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-actions/action/${id}/details`,
        headers,
        data: action,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.deleteActions = async actions => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-actions/actions/delete`,
        headers,
        data: { actions },
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getSpendSummary = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/spend/summary?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getSavingsReport = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/benefits/savings-report?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProjectStats = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/projects?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getTopProjectsBySavings = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/projects/top-by-savings?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getOverduePipelineProjects = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/projects/overdue-pipeline-projects?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getOverdueUnrealisedBenefits = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/benefits/overdue-unrealised-benefits?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getBenefitsBySavingsType = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/benefits/by-savings-type?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getProjectQtys = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/projects/quantities?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getTopStakeholders = async params => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-reports/reports/stakeholders/top?${
          params ? getParamString(params) : ''
        }`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createProjectUpdate = async (projectId, update) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-projects/project/${projectId}/updates`,
        headers,
        data: update,
      });
    })
    .catch(error => {
      console.error(error);
      throw error;
    })
    .finally(() => store.dispatch('setLoading', false));
};

API.getAllCurrencies = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-main/currencies`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createConversionRate = async (orgId, conversionRate) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-organizations/organizations/${orgId}/conversion-rates`,
        headers,
        data: conversionRate,
      });
    })
    .catch(error => {
      console.error(error);
      throw error;
    })
    .finally(() => store.dispatch('setLoading', false));
};

API.getProjectTemplates = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-projects/templates`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.createProjectTemplate = async (projectTemplate) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-projects/templates`,
        headers,
        data: projectTemplate,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.updateProjectTemplate = async (templateId, projectTemplate) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'put',
        url: `${baseURL}-projects/templates/${templateId}/details`,
        headers,
        data: projectTemplate,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.getS3GETURL = async (key) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-organizations/s3-get/${key}`,
        headers
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.getS3PUTURL = async (key, contentType) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-organizations/s3-put`,
        headers,
        data: {
          key,
          contentType
        }
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.downloadFile = async (url, filename = null, onProgressCB = null) => {
  try {
    await API.checkTokenValidity();

    const config = {
      method: 'get',
      url,
      responseType: 'blob', // Or 'arraybuffer' if that works better
      onDownloadProgress: onProgressCB || function () {},
    };

    const response = await axios(config);
    if (response.status !== 200) {
      throw new Error('File download failed');
    }

    const contentType = response.headers['content-type'];
    const isPDF = contentType === 'application/pdf';

    if (isPDF) {
      // Directly open the PDF file in a new tab using the signed URL
      window.open(url, '_blank');
    } else {
      // Handle other file types as before
      const blob = new Blob([response.data]);
      const objectURL = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = objectURL;
      link.target = '_blank';
      if (filename) link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    store.dispatch('setLoading', false);
    return response.data;

  } catch (error) {
    store.dispatch('setLoading', false);
    console.error(error);
    throw error;
  }
}

API.createFile = async (file) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-organizations/files`,
        headers,
        data: file
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.getSelfServiceConfig = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-selfservice/config`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getResponderBenefitApprovals = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-projects/benefit/approvals/respond`,
        headers
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.requestBenefitApproval = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-projects/benefit/approvals/request`,
        headers,
        data
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.cancelBenefitApprovalRequest = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-projects/benefit/approvals/cancel`,
        headers,
        data
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.respondBenefitApproval = async (data) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'post',
        url: `${baseURL}-projects/benefit/approvals/respond`,
        headers,
        data
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
      throw error
    });
};

API.getOrganizationLoad = async () => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-resourcing/organisation`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getActionTemplateGuidance = async (actionTemplateId) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-actions/action-templates/${actionTemplateId}/guidance`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getActionTemplatesGuidance = async (params) => {
  return API.checkTokenValidity()
    .then(() => {
      return axios({
        method: 'get',
        url: `${baseURL}-actions/action-templates/guidance?${params ? getParamString(params) : ''}`,
        headers,
      });
    })
    .then(res => {
      store.dispatch('setLoading', false);
      return res.data;
    })
    .catch(error => {
      store.dispatch('setLoading', false);
      console.error(error);
    });
};

API.getTokensFromCode = async code => {
  var qs = require('qs');
  return axios({
    method: 'post',
    url: `${env.CognitoDomain}/oauth2/token`,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: qs.stringify({
      grant_type: 'authorization_code',
      client_id: env.ClientId,
      redirect_uri: `${window.location.origin}/login/external_provider`, // TODO: setup multiple domains in cognito for .com and .co.uk
      code,
    }),
  });
};

const getParamString = params => {
  return params
    .map(param => {
      if (Array.isArray(param.value)) {
        const vals = param.value
          .map(val => {
            const v = typeof val === 'string' ? `"${val}"` : val;
            return v;
          })
          .join(',');
        const p = `${param.key}=[${vals}]`;
        return p;
      }

      return `${param.key}=${encodeURIComponent(param.value)}`;
    })
    .join('&');
};

export default API;
